var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/CardInfo.js",
  _this = this;
import { IconWrapper, Info, InfoWrapper } from './style';
import React from 'react';
import useDevice from '../../core/hooks/useDevice';
var CardInfo = function CardInfo(_ref) {
  var Icon = _ref.icon,
    children = _ref.children;
  var _useDevice = useDevice(),
    isDesktop = _useDevice.isDesktop,
    isTV = _useDevice.isTV;
  return /*#__PURE__*/React.createElement(InfoWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: isDesktop || isTV ? 20 : 16,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Info, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }, children));
};
export default CardInfo;